import { useState } from 'react';
import { DialogTrigger } from '@radix-ui/react-dialog';
import { useFormat } from '@/frontastic/hooks/useFormat';
import { Button } from '../../ui/button';
import { Label } from '../../ui/customLabel/customLabel';
import { RadioGroup, RadioGroupItem } from '../../ui/customRadio/customRadio';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

const NewChargeOrderModal = ({ Texts, redirectToPlp }: any) => {
  const [open, setOpen] = useState(false);
  const { formatMessage: formatNewChargeOrder } = useFormat({ name: 'new-charge-order' });
  const [selectedOption, setSelectedOption] = useState('yes');

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="h-[40px] max-w-[300px] items-center rounded-md border-[1px] border-foggyGray bg-lightSilver py-1.5 text-lg font-medium">
        {Texts.noChargeOrder}
      </DialogTrigger>
      <DialogContent className="max-w-[520px] bg-white sm:rounded-md">
        <DialogHeader>
          {/* chng-text-25px */}
          <DialogTitle className="text-2xl font-bold">
            <div className="text-2xl font-bold">{Texts.beginNewChargeOrder}</div>
            <div className="text-xs font-normal">{Texts.requiredFields}</div>
          </DialogTitle>
        </DialogHeader>
        <section className="mt-4">
          <RadioGroup defaultValue={selectedOption} onValueChange={setSelectedOption} value={selectedOption}>
            <span className="mb-4 mr-4 flex items-center">
              <RadioGroupItem value={'yes'} id={'yes'} className="mr-2 border-black" />
              <Label htmlFor={'yes'}>
                {formatNewChargeOrder({
                  id: 'radioGroupYes',
                  defaultMessage: 'Yes',
                })}
              </Label>
            </span>
            <span className="mb-4 mr-4 flex items-center">
              <RadioGroupItem value={'No'} id={'No'} className="mr-2 border-black" />
              <Label htmlFor={'No'}>
                {formatNewChargeOrder({
                  id: 'radioGroupNo',
                  defaultMessage: 'No',
                })}
              </Label>
            </span>
          </RadioGroup>
        </section>
        <section className="mt-4 flex justify-start gap-4">
          <Button
            className="rounded-md bg-deepBlue p-4 text-white"
            onClick={() => {
              setOpen(false);
              if (selectedOption === 'yes') {
                // setIsNoChargeOrder(true);
                redirectToPlp();
              }
            }}
          >
            {Texts.beginNewChargeOrder}
          </Button>
          <Button className="p-0 underline" onClick={() => setOpen(false)}>
            {Texts.cancelButton}
          </Button>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default NewChargeOrderModal;
